import { useCallback } from 'react';
import { openBrowserAsync } from 'expo-web-browser';

import { useTelemetry } from '@order/Telemetry';

import { OrgLinks } from '../../../../OrgLinksFooter/OrgLinksFooter.constants';

export const useSocialLinks = (withHref?: boolean) => {
  const { track } = useTelemetry();

  const handleInstagramTelemetry = useCallback(() => {
    if (withHref) void openBrowserAsync(OrgLinks.instagram);

    track('social_media_links', { link: 'instagram' });
  }, [track, withHref]);

  const handleTwitterTelemetry = useCallback(() => {
    if (withHref) void openBrowserAsync(OrgLinks.twitter);

    track('social_media_links', { link: 'twitter' });
  }, [track, withHref]);

  const handleTiktokTelemetry = useCallback(() => {
    if (withHref) void openBrowserAsync(OrgLinks.tiktok);

    track('social_media_links', { link: 'tiktok' });
  }, [track, withHref]);

  const handleSpotifyTelemetry = useCallback(() => {
    if (withHref) void openBrowserAsync(OrgLinks.spotify);

    track('social_media_links', { link: 'spotify' });
  }, [track, withHref]);

  const handleFacebookTelemetry = useCallback(() => {
    if (withHref) void openBrowserAsync(OrgLinks.facebook);

    track('social_media_links', { link: 'facebook' });
  }, [track, withHref]);

  return {
    handleInstagramTelemetry,
    handleTwitterTelemetry,
    handleTiktokTelemetry,
    handleSpotifyTelemetry,
    handleFacebookTelemetry,
  };
};
